import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ResetPasswordForm from '../../components/ResetPasswordForm';
import { useResetPasswordMutation, useVerifyTokenQuery } from '../../redux/api/authApi';




const ResetPasswordPage = () => {
  const { resetToken } = useParams<{ resetToken: string }>() as { resetToken: string };
  const navi = useNavigate()

  const verifyToken = useVerifyTokenQuery(resetToken, { skip: !resetToken })
  const [resetPassword] = useResetPasswordMutation()
  const [userId, setUserId] = useState<number>(-1)


  useEffect(() => {
    if (!resetToken) return navi('/')
    if (verifyToken.isLoading) return
    if (verifyToken.isError) {
      toast.error('El token es inválido')
      return navi('/')
    }
    verifyToken.data && setUserId(verifyToken.data.data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyToken])


  const handleResetPassword = (newPassword: string) => {
    resetPassword({ userId, nuevaPass: newPassword,  token: resetToken })
      .unwrap()
      .then(() => {
        toast.success('Contraseña restablecida con éxito')
        navi('/login')
      })
      .catch(err => {
        toast.error('Ocurrió un error al restablecer la contraseña')
      })

  }
  return (
    <Box sx={{
      backgroundColor: 'background.paper',
      justifyContent: 'center',
      margin: 'auto',
      marginTop: '3rem',
      marginBottom: '3rem',
      maxWidth: '30rem',
      minHeight: 'calc(100vh - 287px)',


    }}>
      <Grid container justifyContent={'center'} p={3}>
        <Box>
          <Typography component="h2" sx={{
            fontSize: '1.5rem',
            lineHeight: '1.5',
            fontFamily: '"DM Sans", sans-serif',
            fontWeight: 700,
            margin: 0,
            textAlign: 'center',
            maxWidth: '25rem',
          }}>
            Restablecé tu contraseña
          </Typography>
          <Typography component="h6" sx={{
            fontSize: '1rem',
            lineHeight: '1.5',
            fontFamily: '"DM Sans", sans-serif',
            fontWeight: 400,
            margin: 0,
            textAlign: 'center',
          }}>
          </Typography>

          <ResetPasswordForm onSubmit={(pass) => {
            handleResetPassword(pass)
          }} />
        </Box>
      </Grid>

    </Box>
  );
};


export default ResetPasswordPage;
